<form [formGroup]="uploadForm" class="row">
  <div class="col-sm-10">
    <div
      [ngClass]="{
        'ng-dirty': file.dirty,
        'ng-invalid': file.errors,
        'ng-touched': file.touched
      }"
      class="form-group"
    >
      <label class="f-label">
        {{ formFields.fields.bulkFileStructures.label.value }}
        <i
          (click)="openExplainationDialog()"
          class="icon-info-circle tooltip-icon"
        ></i>
      </label>

      <label>{{ formFields.fields.fileName.label.value }}</label>
      <div class="input-group">
        <input
          formControlName="file"
          (change)="onFilesSelect($event)"
          #fileElement
          multiple
          type="file"
          class="form-control file-upload"
        />

        <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
          <mat-select formControlName="format">
            <mat-option
              *ngFor="let value of bulkFileStructures"
              [value]="value.fields.Value.value"
            >
              {{ value.fields.Label.value }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <input
          (click)="!selectedFile && openUploadWindow($event)"
          [placeholder]="
            selectedFile && selectedFile.name ? selectedFile.name : ''
          "
          readonly="readonly"
          type="text"
          class="form-control form-custom-control "
        />

        <div class="input-group-append">
          <button
            *ngIf="!selectedFile"
            (click)="openUploadWindow($event)"
            class="btn btn-primary"
          >
            {{ formFields.fields.select.label.value }}
          </button>

          <button
            *ngIf="selectedFile"
            (click)="emitFile($event)"
            [disabled]="uploadForm.invalid"
            class="btn btn-primary"
          >
            <span *ngIf="fileEmitted">{{
              formFields.fields.revalidate.label.value
            }}</span>
            <span *ngIf="!fileEmitted">{{
              formFields.fields.upload.label.value
            }}</span>
          </button>
        </div>
        <button
          *ngIf="selectedFile"
          (click)="deleteFile()"
          type="button"
          class="btn btn-white btn-icon btn-square delete-button"
        >
          <i class="icon-new-delete fs-24"></i>
        </button>
      </div>

      <span *ngIf="file.errors?.required" class="field-validation-error">
        {{ formFields.genericErrors.required.message }}
      </span>

      <span *ngIf="file.errors?.type" class="field-validation-error">
        {{ formFields.genericErrors.validationInvalidFileType.message }}
      </span>

      <span *ngIf="file.errors?.size" class="field-validation-error">
        {{ formFields.genericErrors.validationInvalidFileSize.message }}
      </span>
    </div>
  </div>
</form>
